import { SORT_ORDER } from '../constants/filter.constant';
import {
  DefaultResponse,
  Institution,
  ProcedureGroup,
} from '../interfaces/index';
import api from '../api';
import { AxiosResponse } from 'axios';

const PROCEDURE_URL = '/ris/procedures/v1';

export interface ParamsGetProcedure {
  active?: boolean;
  code?: string;
  created_at_from?: string;
  created_at_to?: string;
  institution_ids?: Array<string>;
  limit?: number;
  modality?: string;
  name?: string;
  offset?: number;
  sort_field?:
    | ''
    | 'active'
    | 'code'
    | 'name'
    | 'modality'
    | 'procedure_group_id'
    | 'user_id'
    | 'created_at'
    | 'updated_at'
    | 'institution_id';
  sort_order?: SORT_ORDER;
  updated_at_from?: string;
  updated_at_to?: string;
  user_ids?: string[];
}
export interface ResponseGetProcedure extends DefaultResponse {
  data: {
    active: boolean;
    code: string;
    compact_name: string;
    created_at: string;
    id: string;
    institution: Pick<
      Institution,
      'code' | 'created_at' | 'id' | 'name' | 'updated_at'
    >;
    institution_id: string;
    modality: string;
    name: string;
    procedure_group: null | ProcedureGroup;
    procedure_group_id: null | string;
    updated_at: string;
    user: null | unknown;
    user_id: null | string;
  }[];
}
export const getProcedures = async (
  params: ParamsGetProcedure = {
    limit: 100,
    offset: 0,
  }
) => {
  const response = (await api({
    url: PROCEDURE_URL,
    method: 'GET',
    params,
    timeout: 30_000,
  })) as AxiosResponse<ResponseGetProcedure>;

  return response.data;
};

interface ParamsGetProcedureGroup {
  created_at_from?: string;
  created_at_to?: string;
  institution_ids?: string[];
  limit?: number;
  name?: string;
  offset?: number;
  sort_field?:
    | ''
    | 'institution_id'
    | 'name'
    | 'user_id'
    | 'created_at'
    | 'updated_at';
  sort_order?: SORT_ORDER;
  updated_at_from?: string;
  updated_at_to?: string;
  user_ids?: string[];
}
export interface ResponseGetProcedureGroup extends DefaultResponse {
  data: {
    createdAt: string;
    id: string;
    institutionId: string;
    name: string;
    procedures: {
      active: boolean;
      code: string;
      compactName: string;
      createdAt: string;
      id: string;
      institutionId: string;
      modality: string;
      name: string;
      procedureGroup: string;
      procedureGroupId: string;
      updatedAt: string;
      userId: string;
    }[];
    updatedAt: string;
    userId: string;
  }[];
}
export const getProceduresGroup = async (
  params: ParamsGetProcedureGroup = {
    limit: 100,
    offset: 0,
  }
) => {
  const response = (await api({
    url: `${PROCEDURE_URL}/groups`,
    method: 'GET',
    params,
    timeout: 30_000,
  })) as AxiosResponse<ResponseGetProcedureGroup>;

  return response.data;
};

export interface ParamsCreateProcedure {
  active: boolean;
  code: string;
  compact_name: string;
  modality: string;
  name: string;
  procedure_group_id: string;
}
export const createProcedure = async (data: ParamsCreateProcedure) => {
  const response = (await api({
    url: PROCEDURE_URL,
    method: 'POST',
    data,
  })) as AxiosResponse<any>;

  return response.data;
};

export interface ParamsCreateProceduresGroup {
  institution_id: string;
  name: string;
}
export const createProcedureGroup = async (
  data: ParamsCreateProceduresGroup
) => {
  const response = (await api({
    url: `${PROCEDURE_URL}/groups`,
    method: 'POST',
    data,
  })) as AxiosResponse<any>;

  return response.data;
};

export interface ParamsUpdateProcedure {
  active: boolean;
  compact_name: string;
  modality: string;
  name: string;
  procedure_group_id: string;
}
export const updateProcedure = async (
  id: string,
  data: ParamsUpdateProcedure
) => {
  const response = (await api({
    url: `${PROCEDURE_URL}/${id}`,
    method: 'PUT',
    data,
  })) as AxiosResponse<any>;

  return response.data;
};

export interface ParamsUpdateProcedureGroup {
  address: string;
  email: string;
  logo: string;
  name: string;
  phone: string;
}
export const updateProcedureGroup = async (
  id: string,
  data: ParamsUpdateProcedureGroup
) => {
  const response = (await api({
    url: `${PROCEDURE_URL}/groups/${id}`,
    method: 'PUT',
    data,
  })) as AxiosResponse<any>;

  return response.data;
};

export const deleteProcedure = async (id: string) => {
  const response = (await api({
    url: `${PROCEDURE_URL}/${id}`,
    method: 'DELETE',
  })) as AxiosResponse<any>;

  return response;
};

export const deleteProcedureGroup = async (id: string) => {
  const response = (await api({
    url: `${PROCEDURE_URL}/groups/${id}`,
    method: 'DELETE',
  })) as AxiosResponse<any>;

  return response;
};
